import { Loader } from '@/components/layout/loading';
import { Wizard } from '@/components/wizard/Wizard';
import { useDAL } from '@/contexts/useDAL';
import { useUser } from '@/contexts/useUser';
import { useWorkspace } from '@/contexts/useWorkspace';

import { SetupOwnCloudRestoreFlow } from './SetupOwnCloudRestoreFlow';
import { type SetupOwnCloudState } from './SetupOwnCloudState';

export default function SetupOwnCloudRestoreWizard({
  onCreated,
}: {
  onCreated: (accountId: string) => Promise<void>;
}) {
  const { rightPanel } = useWorkspace();
  const { currentProjectId, eonAccount } = useUser();
  const dal = useDAL();
  const { data: backupApps, isLoading } =
    dal.onboarding.applications.get('Restore');

  const onFinish = async (state: SetupOwnCloudState) => {
    await onCreated(state.restoreSubscriptionId || '');
    return true;
  };

  // Show loading state while backupApps data is being fetched
  if (isLoading || !backupApps) {
    return <Loader />;
  }

  return (
    <Wizard<SetupOwnCloudState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[SetupOwnCloudRestoreFlow]}
      title='Connect Azure restore account'
      subtitle='Connect a restore account and grant Eon permissions to restore data'
      persistState={true}
      storageKey={`setup-own-cloud-restore`}
      initialState={{
        onboardingFlow: false,
        eonAccountId: eonAccount?.id,
        projectId: currentProjectId,
        tenantId: backupApps.customerTenantId,
        restoreConnectType: 'subscription',
        managementApplicationId: backupApps.managementAppId,
        backupAppId: backupApps.backupAppId,
        adxClusterIdentity: backupApps.adxClusterManagedIdentityPrincipalId,
        restoreManagedIdentityRegion: 'eastus2',
      }}
    />
  );
}
